// components/Content.js
import React, {useContext , useCallback , useEffect , useState} from 'react';
import {
Row,
Col,
Button,
Space,
Form,
}from 'antd';

import {
  SUCCESS_CODE,
} from '../../../../lib/const'


import { getFutureDetailVocReport}  from '../../../../services/vocReportService';
import {SearchFutureVocContext} from '../searchContext';
import { formatPrintDateTimeBE, buildPdfFooterBE } from '../../../../lib/utils/date';
import "../../style.css";
// import "../../../../assets/font/NotoSansThai-VariableFont_wdth,wght-normal"
// import "../../../../assets/font/NotoSansThai-Regular.js"
// import jsPDF from 'jspdf';
// import autoTable from 'jspdf-autotable';

import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "../../../../assets/font/vfs_fonts_thsarabun_new";
import {
  Document,
  Packer,
  Paragraph,
  Table,
  TableRow,
  TableCell,
  TextRun,
  VerticalAlign,
  WidthType,
  AlignmentType,
  Header,
  Footer,
} from "docx";
import { saveAs } from "file-saver";


const Content = ({roleUser,typeFuture}) => {

  const {
      searchValues,
      search,
      setSearch,
    } = useContext(SearchFutureVocContext);
    const [data , setData] = useState();
    const [form] = Form.useForm();
// pdfmake 0.3.x: ใช้ addVirtualFileSystem/setFonts แทน pdfMake.vfs/pdfMake.fonts (API เดิมของ 0.2.x ถูกถอดออก)
pdfMake.addVirtualFileSystem(pdfFonts.pdfMake.vfs);
pdfMake.setFonts({
  "Sarabun": {
    normal: "THSarabunNew.ttf",
    bold:   "THSarabunNew-Bold.ttf"
  }
});
  const exportToDocx = () => {
  let industry = '';
  const defaultIndustry =
        'Stable Anchor : First S-Curve (ยานยนต์สมัยใหม่ อิเล็กทรอนิกส์อัจฉริยะ การแปรรูปอาหาร)\n' +
        'Stable Anchor : Reforming (ปิโตรเคมี-พลาสติก)\n' +
        'Raising Stars : First S-Curve (เกษตรและชีวภาพ)\n' +
        'Raising Stars : New S-Curve (ดิจิทัล/ศูนย์ข้อมูล Data Center หุ่นยนต์ โลจิสติกส์)';
      if (typeFuture === 1){
      industry = data?.industryType && data?.industryType !== "" 
            ? getIndustryType(data?.industryType)
            : 'กลุ่มลูกค้า BCG และ ฐานเศรษฐกิจ';
            }else{
      industry = data?.industryType && data?.industryType !== "" 
            ? getIndustryType(data?.industryType)
            :  defaultIndustry ; }
  const head = [
          new TableRow({
            tableHeader: true,
            children: [
              new TableCell({
                rowSpan: 1,
                verticalAlign: VerticalAlign.CENTER,
                children: [new Paragraph({ text: "กลุ่มลูกค้า", alignment: "center", bold: true })],
              }),
              new TableCell({
                columnSpan: 3,
                verticalAlign: VerticalAlign.CENTER,
                children: [new Paragraph({ text: "เสียงของลูกค้า", alignment: "center", bold: true })],
              }),
              
              new TableCell({
                rowSpan: 1,
                verticalAlign: VerticalAlign.CENTER,
                children: [new Paragraph({ text: "หน่วยงานที่ต้องนำ VOC ไปใช้", alignment: "center", bold: true })],
              }),
              new TableCell({
                rowSpan: 1,
                verticalAlign: VerticalAlign.CENTER,
                children: [new Paragraph({ text: "วัตถุประสงค์ของ\nการใช้ VOC", alignment: "center", bold: true })],
              }),
            ],
          }),
          // new TableRow({
          //   tableHeader: true,
          //   children: [
          //     new TableCell({ children: [new Paragraph({ text: "หัวข้อ",       alignment: "center", bold: true })] }),
          //     new TableCell({ children: [new Paragraph({ text: "ต้องการ/คาดหวัง", alignment: "center", bold: true })] }),
          //     new TableCell({ children: [new Paragraph({ text: "รายละเอียด",   alignment: "center", bold: true })] }),
          //   ],
          // }),
        ];
  const dataRows = [];
  
  dataSource.forEach((item, i) => {
          let groupText = ''
          if (typeFuture === 1){
          groupText = i === 0
            ? (item.industryType === "กลุ่มลูกค้าฐานเศรษฐกิจ"
                ? "กลุ่มลูกค้าฐาน\nเศรษฐกิจ"
                : item.industryType === "กลุ่มลูกค้า BCG"
                ? "กลุ่มลูกค้า BCG"
                : "กลุ่มลูกค้า BCG \n กลุ่มลูกค้าฐาน\nเศรษฐกิจ")
            : "";
          }else{
            groupText = i === 0
            ? industry : "";
          }
          // แถว "ต้องการ"
          dataRows.push(new TableRow({
            width: {
                size: 1700, 
                type: WidthType.DXA,
              },
            children: [
              ...(i === 0 ? [new TableCell({
                rowSpan: 8,
                verticalAlign: VerticalAlign.CENTER,
                children: [new Paragraph({ text: groupText, alignment: AlignmentType.CENTER })]
              })] : []),
              new TableCell({
                rowSpan: 2,
                verticalAlign: VerticalAlign.CENTER,
                width: {
                    size: 680, 
                    type: WidthType.DXA,
                  },
                children: [new Paragraph({ text: getTopicInThai(item.topic), alignment: AlignmentType.CENTER })]
              }),
              new TableCell({
                width: {
                    size: 680, 
                    type: WidthType.DXA,
                  },
                children: [new Paragraph({ text: getCategoryInThai(item.topicitem.want), alignment: AlignmentType.CENTER })]
              }),
              new TableCell({
                children: item.topicitem.wantItem?.details.map(d =>
                  new Paragraph({ text: d, alignment: AlignmentType.LEFT })
                ) || [new Paragraph("-")]
              }),
              new TableCell({
                rowSpan: 2,
                verticalAlign: VerticalAlign.CENTER,
                children: [new Paragraph({
                  // text: (item.lineOfWorkId || [])
                  //   .filter((v, i, self) => self.indexOf(v) === i)
                  //   .map(id => lineOfWork.find(x => x.lineOfWork === id)?.nameTh || "")
                  //   .join("\n"),
                  text:"",
                  alignment: AlignmentType.CENTER
                })]
              }),
              new TableCell({ rowSpan: 2, children: [new Paragraph("")] })
            ]
          }));
  
          // แถว "คาดหวัง"
          dataRows.push(new TableRow({
            children: [
              new TableCell({
                width: {
                    size: 680, 
                    type: WidthType.DXA,
                  },
                children: [new Paragraph({ text: getCategoryInThai(item.topicitem.expected), alignment: AlignmentType.CENTER })]
              }),
              new TableCell({
                children: item.topicitem.expectedItem?.details.map(d =>
                  new Paragraph({ text: d, alignment: AlignmentType.LEFT })
                ) || [new Paragraph("-")]
              })
            ]
          }));
        });
  // const industry = data?.industryType && data?.industryType !== "" 
  //       ? getIndustryType(data?.industryType) 
  //       : 'กลุ่มลูกค้า BCG และ ฐานเศรษฐกิจ';
  
  const quarter = data?.quarter || "-";
  const yearOfBudget = data?.yearOfBudget ? Number(data?.yearOfBudget) + 543 : "-" ;
  const industryLines = String(industry || "").split("\n").filter(Boolean);

  const doc = new Document({
    styles: {
       paragraphStyles: [
        {
          id: "Normal",           
          name: "Normal",
          basedOn: "Normal",      
          quickFormat: true,
          run: {
            font: "TH Sarabun New", 
            size: 22,               
          },
          paragraph: {
            alignment: AlignmentType.CENTER,
            spacing: { line: 276 }, 
          },
        },
        {
          id: "headerMain",
          basedOn: "Normal",
          quickFormat: true,
          run: { bold: true, size: 32 },
          paragraph: { spacing: { after: 100 } },
        },
      ],
    },
    sections: [
      {
        properties: {},
        // headers: {
        //   default: new Header({
        //     children: [
        //       new Paragraph({
        //         children: [ new TextRun({ text: `ลูกค้าอนาคต ${industry} (ณ สิ้น Q ${quarter} ปีงบประมาณ ${yearOfBudget})`, bold: true }) ],
        //         alignment: AlignmentType.CENTER,
        //         spacing: { after: 200 },
        //       }),
        //     ],
        //   }),
        // },

        headers: {
          default: new Header({
            children: [
              new Paragraph({
                children: [new TextRun({ text: "ลูกค้าอนาคต", bold: true })],
                alignment: AlignmentType.CENTER,
                spacing: { after: 80 },
              }),

              ...industryLines.map(line =>
                new Paragraph({
                  children: [new TextRun({ text: line })],
                  alignment: AlignmentType.CENTER,
                  spacing: { after: 40 },
                })
              ),

              new Paragraph({
                children: [
                  new TextRun({ text: `(จัดลำดับ) (ณ สิ้น Q${quarter} ปีงบประมาณ ${yearOfBudget})` }),
                ],
                alignment: AlignmentType.CENTER,
                spacing: { after: 120 },
              }),
            ],
          }),
        },
        footers: {
          default: new Footer({
            children: [
              new Paragraph({
                alignment: AlignmentType.RIGHT,
                children: [ new TextRun({ text: formatPrintDateTimeBE(new Date()), size: 18 }) ],
              }),
            ],
          }),
        },
        children: [
        new Table({
          columnWidths: [2380, 3400, 2040, 2040],
          width: { size: 100, type: WidthType.PERCENTAGE },
          rows: [...head, ...dataRows],
        }),
        ],
      },
    ],
  });

  Packer.toBlob(doc).then((blob) => {
    saveAs(blob, `VOC_Report_Future_${new Date().toLocaleDateString("th-TH")}.docx`);
  });
};

  const exportToPDF = () => {
    const head = [
      [
        { text: "กลุ่มลูกค้า", rowSpan: 1, style: "tableHeader", alignment: "center" },
        { text: "เสียงของลูกค้า", colSpan: 3, style: "tableHeader", alignment: "center" },
        {},
        {},
        { text: "หน่วยงานที่ต้องนำ VOC ไปใช้", rowSpan: 1, style: "tableHeader", alignment: "center" },
        { text: "วัตถุประสงค์ของ\nการใช้ VOC", rowSpan: 1, style: "tableHeader", alignment: "center" }
      ],
      // [
      //   {},
      //   { text: "หัวข้อ", style: "tableHeader", alignment: "center" },
      //   { text: "ต้องการ/คาดหวัง", style: "tableHeader", alignment: "center" },
      //   { text: "รายละเอียด", style: "tableHeader", alignment: "center" },
      //   {}, 
      //   {}  
      // ]
    ];
    let industry = '';
    
    const defaultIndustry =
      'Stable Anchor : First S-Curve (ยานยนต์สมัยใหม่ อิเล็กทรอนิกส์อัจฉริยะ การแปรรูปอาหาร)\n' +
      'Stable Anchor : Reforming (ปิโตรเคมี-พลาสติก)\n' +
      'Raising Stars : First S-Curve (เกษตรและชีวภาพ)\n' +
      'Raising Stars : New S-Curve (ดิจิทัล/ศูนย์ข้อมูล Data Center หุ่นยนต์ โลจิสติกส์)';
    if (typeFuture === 1){
    industry = data?.industryType && data?.industryType !== "" 
          ? getIndustryType(data?.industryType)
          : 'กลุ่มลูกค้า BCG และ ฐานเศรษฐกิจ';
          }else{
    industry = data?.industryType && data?.industryType !== "" 
          ? getIndustryType(data?.industryType)
          :  defaultIndustry ; }
    const quarter = data?.quarter || "-";
    const yearOfBudget = data?.yearOfBudget ? Number(data?.yearOfBudget) + 543 : "-" ;
    const industryLines = industry.split("\n").filter(Boolean);
    // const body = dataSource.map((item,index) => [
        
    //     {
    //       text: index === 0
    //       ? item.industryType === "กลุ่มลูกค้าฐานเศรษฐกิจ"
    //         ? "กลุ่มลูกค้าฐาน\nเศรษฐกิจ"
    //         : item.industryType === "กลุ่มลูกค้า BCG"
    //         ? "กลุ่มลูกค้า BCG"
    //         : "กลุ่มลูกค้า BCG \n กลุ่มลูกค้าฐาน\nเศรษฐกิจ"
    //       : "",
    //       style:"cellText"
    //     },
    //     {
    //       text: item.topic || "",
    //       style:"cellText"
    //     },
    //     {
    //       text: item.category,
    //       style:"cellText"
    //     },
       
    //     {
    //       text: (item.details || []).join("\n"), 
    //       alignment: "left",
    //       noWrap: false
    //     },
    //     "",
    //     "",
        
    //   ]);
    const body =[];
      dataSource.forEach((item,index) => {
        const topicTh = getTopicInThai(item.topic) || "-";
        // const wantExcept = (item.topicitem?.want || item.topicitem?.expected);
        const wantText = (item.topicitem?.wantItem?.details || ["-"]).join("\n");
        const expectedText = (item.topicitem?.expectedItem?.details || ["-"]).join("\n");
        // const expectedText = []
        // .concat(item.topicitem?.expectedItem?.details || "-")
        // .join("\n");
        // const expectedText = (["-"] || ["-"]).join("\n");
       
        

        // แถวบน
        body.push([
          index === 0 ? { text: industry, rowSpan: 8, style: "cellText" } : {},     
          { text: topicTh,rowSpan:2 , style: "cellText" },  
          { text: "ต้องการ", style: "cellText" },                 
          { text: wantText, style: "cellText" },                    
          { text: "", rowSpan: 2, style: "cellText" },   
          { text: "", rowSpan: 2 }                                   
        ]);
        body.push([
          {},     
          {},  
          { text: "คาดหวัง", style: "cellText" },                 
          { text: expectedText, style: "cellText" },                   
          {},   
          {}                                  
        ]);
      });
      
    // const docDefinition = {
    //   // header: (_currentPage, _pageCount) => ({
    //   //   text: `ลูกค้าอนาคต ${industry} (จัดลำดับ) (ณ สิ้น Q${quarter} ปีงบประมาณ ${yearOfBudget})`,
    //   //   style: "tableTitle",
    //   //   alignment: "center",
    //   //   margin: [0, 10, 0, 10]
    //   // }),
    //   pageMargins: [30, 100, 30, 40],
    //   header: (_currentPage, _pageCount) => ({
        
    //     margin: [0, 10, 0, 10],
    //     stack: [
    //       {
    //         text: "ลูกค้าอนาคต",
    //         style: "tableTitle",
    //         alignment: "center",
    //       },
    //       ...industryLines.map(t => ({
    //         text: t,
    //         style: "industryLine",
    //         alignment: "center",
    //       })),
    //       {
    //         text: `(จัดลำดับ) (ณ สิ้น Q${quarter} ปีงบประมาณ ${yearOfBudget})`,
    //         style: "industryLine",
    //         alignment: "center",
    //       }
    //     ]
    //   }),
    //   content: [
    //     {
    //       table: {
    //         headerRows: 2,
    //         widths: [60, 55, 50, 180, 80, 60],
    //         body: [
    //           ...head,
    //           ...body
    //         ]
    //       },
    //       layout: {
            
    //         paddingTop: (rowIndex, node) => node.table.body[rowIndex].some(cell => cell.text?.includes("\n")) ? 4 : 8,
    //         paddingBottom: (rowIndex, node) => node.table.body[rowIndex].some(cell => cell.text?.includes("\n")) ? 4 : 8,
    //         hLineColor: () => "#aaa",
    //         vLineColor: () => "#aaa"
    //       }
    //     }
    //   ],
    //   defaultStyle: {
    //     font: "Sarabun",
    //     fontSize: 10,
        
    //   },
    //   styles: {
    //     tableTitle: {
    //       fontSize: 14,
    //       bold: true
    //     },
    //     tableHeader: {
    //       fillColor: [230, 230, 230],
    //       alignment: "center",
    //       valign: "middle",
    //       bold: true
    //     },
    //     cellText: {
    //       alignment: "center",
    //       valign: "middle",
    //       lineHeight: 1.3 
    //     },
        
    //   }
    // };
    const safeIndustryLines = Array.isArray(industryLines) ? industryLines.filter(Boolean) : [];
    const safeQuarter = (data?.quarter ?? "-");
    const safeYearBE = Number.isFinite(Number(data?.yearOfBudget))
      ? String(Number(data.yearOfBudget) + 543)
      : "-";

    const docDefinition = {
      pageMargins: [30, 100, 30, 40],   

      header: (currentPage) => {
        if (currentPage !== 1) return {}; 

        return {
          margin: [0, 10, 0, 10],
          stack: [
            { text: "ลูกค้าอนาคต", style: "tableTitle", alignment: "center" },
            ...safeIndustryLines.map((t) => ({
              text: t,
              style: "industryLine",
              alignment: "center",
            })),
            {
              text: `(จัดลำดับ) (ณ สิ้น Q${safeQuarter} ปีงบประมาณ ${safeYearBE})`,
              style: "industryLine",
              alignment: "center",
            },
          ],
        };
      },

      footer: buildPdfFooterBE(new Date()),

      content: [
        {
          margin: (currentNode) => [0, 0, 0, 0],
          table: {
            headerRows: 2,
            widths: [60, 55, 50, 180, 80, 60],
            body: [...head, ...body],
          },
          layout: {
            paddingTop: (rowIndex, node) =>
              node.table.body[rowIndex].some(
                (cell) =>
                  cell &&
                  typeof cell === "object" &&
                  "text" in cell &&
                  String(cell.text ?? "").includes("\n")
              )
                ? 4
                : 8,
            paddingBottom: (rowIndex, node) =>
              node.table.body[rowIndex].some(
                (cell) =>
                  cell &&
                  typeof cell === "object" &&
                  "text" in cell &&
                  String(cell.text ?? "").includes("\n")
              )
                ? 4
                : 8,
            hLineColor: () => "#aaa",
            vLineColor: () => "#aaa",
          },
        },
      ],

      defaultStyle: { font: "Sarabun", fontSize: 10 },

      styles: {
        tableTitle: { fontSize: 14, bold: true },
        industryLine: { fontSize: 10 },
        tableHeader: {
          fillColor: [230, 230, 230],
          alignment: "center",
          valign: "middle",
          bold: true,
        },
        cellText: { alignment: "center", valign: "middle", lineHeight: 1.3 },
      },
    };


    const pad = n => String(n).padStart(2, "0");
    const now = new Date();
    const timestamp = 
      now.getFullYear()
      + pad(now.getMonth() + 1)
      + pad(now.getDate())
      + "_"
      + pad(now.getHours())
      + pad(now.getMinutes())
      + pad(now.getSeconds());

    const filename = `VOC_Future_${timestamp}.pdf`;
    pdfMake.createPdf(docDefinition).download(filename);
};
    // const exportToPDF = () => {
    //   const doc = new jsPDF({
        
    //     orientation: "portrait",
    //     unit: "mm",
    //     format: "a4",
    //   });
    //   const industryType = getIndustryType(data?.industryType)
    //   console.log(industryType)
    // const quarter = data?.quarter || "-";
    // const yearOfBudget = Number(data?.yearOfBudget) + 543 || "-";
    // const industry = getIndustryType(data?.industryType) && getIndustryType(data?.industryType) !== "" 
    //   ? getIndustryType(data?.industryType) 
    //   : 'กลุ่มลูกค้า BCG และ ฐานเศรษฐกิจ';
    //   console.log(industry)
    //   const titletxt = `ลูกค้าอนาคต ${industry} (จัดลำดับ) (ณ สิ้น Q${quarter} ปีงบประมาณ ${yearOfBudget})`;
    //   doc.setFont("NotoSansThai"); 
    //   doc.setFontSize(14);
    //   doc.text(titletxt, 28, 12);
    //   // กำหนดหัวตาราง
    //   const head = [
    //     [
    //       { content: "กลุ่มลูกค้าปัจจุบัน", rowSpan: 2 ,},
    //       { content: "เสียงของลูกค้า", colSpan: 3 },
    //       { content: "หน่วยงานที่ต้องนำ VOC ไปใช้", rowSpan: 2 },
    //       { content: "วัตถุประสงค์ของการใช้ VOC", rowSpan: 2 },
    //     ],
    //     ["หัวข้อ", "ต้องการ/คาดหวัง", "รายละเอียด"],
    //   ];
    //   const body = dataSource.map((item,index) => [
    //     index === 0 ? 
    //       (getIndustryType(item.industryType) && getIndustryType(item.industryType) !== "" 
    //         ? getIndustryType(item.industryType) 
    //         : 'กลุ่มลูกค้า BCG \n กลุ่มลูกค้าฐานเศรษฐกิจ')
    //       : '' ,
    //     getTopicInThai(item.topic),
    //     getCategoryInThai(item.category),
    //     (item.details || []).join("\n"),
    //     ,
    //     ,
    //     ,
    //   ]);
      
    
    //   autoTable(doc, {
    //     head,
    //     body,
    //     startY: 20,
    //     styles: {
    //       font: "NotoSansThai",
    //       fontSize: 8,
    //       cellPadding: 4,
    //       valign: "middle",
    //       halign: "center",
    //       lineColor: "#000",
    //       lineWidth: 0.5,
    //     },
    //     headStyles: {
    //       fillColor: [230, 230, 230],
    //       textColor: 0,
    //       fontStyle: "bold",
    //     },
    //     bodyStyles: {
    //       textColor: 20,
    //     },
    //     columnStyles: {
    //       0: { cellWidth: 20 },  
    //       1: { cellWidth: 32 },  
    //       2: { cellWidth: 20 }, 
    //       3: { cellWidth: 20 },
    //       4: { cellWidth: 30 },
    //       5: { cellWidth: 20 },
    //       3: { halign: "left" },

    //     },
    //     theme: "grid",
    //   });
    
    //   doc.save("VOC_Report_Future.pdf");
    // };
    
    
      const fetchDetail = useCallback(
          async (searchValue) => {
              const res = await getFutureDetailVocReport(searchValue);
              if (res.data.code === SUCCESS_CODE) {
                  const { objectValue } = res.data;
                  setData(objectValue[0]);
  
              }
              
          },
          
          [setData,searchValues]
      );
      useEffect(() => {
        if (search) {
          fetchDetail(searchValues);
          setSearch(false);
        }
      }, [ fetchDetail]);
    //   const getTopicInThai = (topic) => {
    //     switch (topic) {
    //         case "productAndService":
    //             return "ผลิตภัณฑ์และบริการ";
    //         case "support":
    //             return "การสนับสนุน";
    //         case "transaction":
    //             return "การทำธุรกรรม";
    //         case "crm":
    //             return "การจัดการลูกค้า";
    //         default:
    //             return topic;
    //     }
    // };
    
    const getIndustryType = (industryType) =>{
        switch (industryType) {
            case 'ff3b7ae8-d200-4ff2-96bb-85720f1ae4e4':
                return "กลุ่มลูกค้าฐานเศรษฐกิจ";
            case '02915df5-f9d1-4193-a251-396897c5b4d1':
                return "กลุ่มลูกค้า BCG";
            case '38822bf4-3411-11ee-b359-005056014b8c':
                return 'ไม่สามารถระบุข้อมูลได้' ;
            case '4d3d303d-ca38-11f0-8f16-005056014b8c' :
              return 'Stable Anchor : First S-Curve (ยานยนต์สมัยใหม่ อิเล็กทรอนิกส์อัจฉริยะ การแปรรูปอาหาร)';
            case '4d3d4568-ca38-11f0-8f16-005056014b8c' :
              return 'Stable Anchor : Reforming (ปิโตรเคมี-พลาสติก)';
            case '4d3e2cfb-ca38-11f0-8f16-005056014b8c' :
              return 'Raising Stars : First S-Curve (เกษตรและชีวภาพ)';
            case '4d3e2e23-ca38-11f0-8f16-005056014b8c' :
              return 'Raising Stars : New S-Curve (ดิจิทัล/ศูนย์ข้อมูล Data Center หุ่นยนต์ โลติสติกส์)';
            case '4d3e2e97-ca38-11f0-8f16-005056014b8c' :
              return 'ไม่สามารถระบุข้อมูลได้';
        }
    };
    
    // const getCategoryInThai = (category) => {
    //     switch (category) {
    //         case "Want":
    //             return "ต้องการ";
    //         case "Expected":
    //             return "คาดหวัง";
    //         default:
    //             return category;
    //     }
    // };
      const dataSource = [
          {
              key: "1",
              topic: "productAndService",
              topicitem :{
                want: "Want",
                wantItem:{
                  details: data?.productAndServiceWantList.length > 0 ? data?.productAndServiceWantList : ["-"]
                },
                expected: "Expected",
                expectedItem:{
                    details: data?.productAndServiceExpectedList.length > 0 ? data?.productAndServiceExpectedList : ["-"]
                },
              },
              customerGroupByAge:data?.customerGroupByAge || ["-"],
              lineOfWorkId:data?.lineOfWorkId || ["-"]
            ,
          },
          {
              key: "2",
              topic: "support",
              topicitem :{
                want: "Want",
                wantItem:{
                  details: data?.supportWantList.length > 0 ? data?.supportWantList : ["-"]

                },
                expected: "Expected",
                expectedItem:{
                  details: data?.supportExpectedList.length > 0 ? data?.supportExpectedList : ["-"]
                },
              },
          },
          {
              key: "3",
              topic: "transaction",
              topicitem :{
                want: "Want",
                wantItem:{
                  details: data?.transactionWantList.length > 0 ? data?.transactionWantList : ["-"]
                },
                expected: "Expected",
                expectedItem:{
                  details: data?.transactionExpectedList.length > 0 ? data?.transactionExpectedList : ["-"]
                },
              },
          },
          {
              key: "4",
              topic: "crm",
              topicitem :{
                want: "Want",
                wantItem:{
                  details: data?.crmList.length > 0 ? data?.crmList : ["-"]

                },
                expected: "Expected",
                expectedItem:{
                    details: ["-"] || ["-"]
                },
              },
          },
      ];
      const getTopicInThai = (topic) => {
        switch (topic) {
            case "productAndService":
                return "ผลิตภัณฑ์\nและบริการ";
            case "support":
                return "การสนับสนุน";
            case "transaction":
                return "การทำธุรกรรม";
            case "crm":
                return "การจัดการลูกค้า";
            default:
                return topic;
        }
    };
    
    const getGroupbyAge = (customerGroupByAge) =>{
        switch (customerGroupByAge) {
            case 'f21fe673-10a2-11ee-9f58-b6e1cd76768a':
                return "กลุ่มลูกค้าไม่เกิน 3 ปี";
            case 'f2290fc6-10a2-11ee-9f58-b6e1cd76768a':
                return 'กลุ่มลูกค้า 3-10 ปี';
            case 'f2323054-10a2-11ee-9f58-b6e1cd76768a':
                return 'กลุ่มลูกค้ามากกว่า 10 ปี' ;
            case '8548650e-340e-11ee-b359-005056014b8c':
                return 'ไม่สามารถระบุข้อมูลได้' ;
        }
    };
    
    const getCategoryInThai = (category) => {
        switch (category) {
            case "Want":
                return "ต้องการ";
            case "Expected":
                return "คาดหวัง";
            default:
                return category;
        }
    };
    console.log("test :",dataSource);
  return (
   
      <Row gutter={[24, 24]} style={{ marginTop: 15 }}>
        <Col span={24}>
        </Col>
        <Col span={24}>
        
            <Form
                ref={form}
                form={form}
                layout="vertical"
                style={{ width: "100%", padding: "0 30px" }}
                >
                <Row gutter={[24, 16]} style={{ marginBottom: 10 }}>
                    <Col span={24} align="right">
                        <Space>
                          <Button
                                type="primary"
                                disabled={!roleUser[0]?.isExport}
                                onClick={() =>
                                  exportToDocx()
                                }
                            >
                                Word
                          </Button>
                            <Button
                                type="primary"
                                disabled={!roleUser[0]?.isExport}
                                onClick={() =>
                                  exportToPDF()
                                }
                            >
                                PDF
                            </Button>
                        </Space>
                    </Col>
                </Row>
                <div id="form-container">                  
                    <Row
                    gutter={[16, 24]}
                    className="card"
                    style={{ marginBottom: 30 }}
                    >
                        
                        

                        <div id="form-container">
                          <div className="main-title">
                            
                           ลูกค้าอนาคต {data?.industryType ? dataSource[0].industryType : "-"} (จัดลำดับ) (ณ สิ้น Q{data?.quarter || "-"} ปีงบประมาณ {data?.yearOfBudget ? Number(data?.yearOfBudget) + 543 : "-"})
                          </div>

                          <table className="detail-table">
                            <colgroup>
                              <col style={{ width: "15%" }} />  {/* กลุ่มลูกค้า */}
                              <col style={{ width: "10%" }} />  {/* หมวด (ต้องการ/คาดหวัง) */}
                              <col style={{ width: "10%" }} />  {/* รายละเอียดเสียงลูกค้า */}
                              <col style={{ width: "40%" }} />  {/* หน่วยงาน */}
                              <col style={{ width: "20%" }} />  {/* วัตถุประสงค์ */}
                              <col style={{ width: "25%" }} />  {/* วัตถุประสงค์ */}
                            </colgroup>
                            <thead>
                              <tr>
                                <th rowspan="1" >กลุ่มลูกค้าอนาคต</th>
                                <th colspan="3" >เสียงของลูกค้า</th>
                                <th rowspan="1" >หน่วยงานที่ต้องนำ VOC ไปใช้</th>
                                <th rowspan="1" >วัตถุประสงค์ของการใช้ VOC</th>
                              </tr>
                              {/* <tr>
                                <th style={{ width: "10%" }}></th>
                                <th style={{ width: "10%" }}></th>
                                <th style={{ width: "40%" }}></th>
                              </tr> */}
                            </thead>
                            <tbody>
                              {dataSource.map((item, index) => (
                                <React.Fragment key={index}>
                                  {/* แถว ต้องการ */}
                                  <tr key={`want-${index}`}>
                                    <td rowSpan={2}>
                                      {item.customerGroupByAge
                                        ?.filter((value, i, self) => self.indexOf(value) === i)
                                        .map((group, i) => (
                                          <div key={i}>{getGroupbyAge(group)}</div>
                                        ))}
                                    </td>
                                    <td rowSpan={2}>{getTopicInThai(item.topic) || "-"}</td>
                                    <td>{getCategoryInThai(item.topicitem?.want) || "-"}</td>
                                    <td style={{ textAlign: "left" }}>
                                      {item.topicitem?.wantItem?.details?.map((detail, i) => (
                                        <div key={i}>{detail}</div>
                                      ))}
                                      
                                    </td>
                                    <td rowSpan={2}>
                                      {/* {item.lineOfWorkId
                                        ?.filter((v, i, self) => self.indexOf(v) === i)
                                        .map(id => {
                                          const lo = lineOfWork.find(x => x.lineOfWork === id);
                                          return lo?.nameTh || "";
                                        })
                                        .sort((a, b) => a.localeCompare(b, "th"))
                                        .map((nameTh, i) => <div key={i}>{nameTh}</div>)} */}
                                    </td>
                                    <td rowSpan={2}></td>
                                  </tr>

                                  {/* แถว คาดหวัง */}
                                  <tr key={`expect-${index}`}>
                                    <td>{getCategoryInThai(item.topicitem?.expected) || "-"}</td>
                                    <td style={{ textAlign: "left" }}>
                                      {item.topicitem?.expectedItem?.details?.map((detail, i) => (
                                        <div key={i}>{detail}</div>
                                      ))}
                                    </td>
                                  </tr>
                                </React.Fragment>
                              ))}
                            </tbody>
                          </table>
                        </div>

                    </Row>
                </div>  
            </Form>
        </Col>
      </Row>

  );
};

export default Content;